'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isTuesday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isTuesday.js
// module id = 561
// module chunks = 0